module.exports = __webpack_public_path__ + "static/img/buble_like.35fc0df.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/buble_like.gif
// module id = FAOZ
// module chunks = 0